import {
  GET_APPOINTMENT_DETAIL,
  GET_APPOINTMENT_DETAIL_SUCCESS,
  GET_APPOINTMENT_DETAIL_FAILURE,
} from 'store/getAppointmentDetail/getAppointmentDetailAcition';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getAppointmentDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENT_DETAIL:
      return { ...state, loading: true };
    case GET_APPOINTMENT_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_APPOINTMENT_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentDetailReducer;
